'use strict'
import io from 'socket.io-client'
import getSocketParams from './getSocketParams'

let socket = null

export function connectSocket(userId, callId, userType){

    const socketParams = getSocketParams()
    socket = io(socketParams.host + '/controlProductivity', { path: socketParams.path, transports : ['websocket']})
    socket.on('connect', () => {
        socket.emit('create', {userId: userId, callId: callId, socketId: socket.id, userType: userType})
    })
}

export function disconnectSocket(){

    if(socket.connected) socket.disconnect()

}